'use strict';

const jQuery = require('jquery');
const flatpickr = require('flatpickr');
const dateFormat = require('dateformat');

const Translator = require('./../../../../core/translator');

const FormBuilder = require('./../../builder');
const ElementClass = require('./../../elementClass');

const fr = require('flatpickr/dist/l10n/fr.js').default.fr;
const en = require('flatpickr/dist/l10n/default.js').default;

FormBuilder.register('datetimepicker', function(config) {
  let self = {};

  self = new ElementClass(config);

  let pickerFormat = 'yyyy-mm-dd';

  if (config.enable_time) {
    pickerFormat = pickerFormat + ' HH:MM:ss';
  }

  self.render = function(wrap) {
    let $element = jQuery('<input/>');
    let $label;

    $element.attr('type', 'text');
    $element.attr('name', self.name);

    if (self.disabled) {
      $element.attr('disabled', self.disabled);
      $element.addClass('disabled');
    }

    if (undefined !== self.placeholder) {
      $element.attr('placeholder', self.placeholder);
    }

    let dateFormat = (Translator.getLocale() === 'en' ? 'Y-m-d' : 'd/m/Y') + (config.enable_time ? ' H:i' : '');
    let format = Translator.getLocale() === 'en' ? '\\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])' : '(0?[1-9]|[12][0-9]|3[01])[\\/\\-](0?[1-9]|1[012])[\\/\\-]\\d{4}';
    let regex = new RegExp('^' + format + '(?:(?:\\s([0-1]\\d|[2][0-3])\\:([0-5]\\d)?)?)' + '$');

    let options = {
      'enableTime': config.enable_time,
      'time_24hr': true,
      'locale': Translator.getLocale() === 'en' ? en : fr,
      'dateFormat': dateFormat,
      'allowInput': true,
      'position': config.position || 'below',
      'allowInvalidPreload': true,
      'onOpen': function() {
        const $elem = jQuery(this.element);

        if ($elem.val() === '') {
          this.setDate(Date.now(), false, pickerFormat);
        }

        $elem.data('value', $elem.val());
      },
      'onClose': function() {
        const $elem = jQuery(this.element);

        if ($elem.val() === '') {
          this.setDate($elem.data('value'), false, pickerFormat);
        }

        if (!config.range) {
          if ($elem.val().match(regex)) {
            self.picker.setDate(self.picker.parseDate($elem.val()), false, pickerFormat);
          } else {
            self.picker.clear();
          }
        }
      },
    };

    if (config.range) {
      options['mode'] = 'range';
    }

    self.picker = flatpickr.default($element.get(0), options);

    if (self.value !== undefined && self.value !== null && self.value !== '') {
      if (Array.isArray(self.value)) {
        let date1 = new Date(self.value[0]);
        let date2 = new Date(self.value[1]);
        self.picker.setDate([date1, date2], false);
      } else {
        self.picker.setDate(new Date(self.value));
      }
    }

    if (self.elementClass) {
      $element.addClass(self.elementClass);
    }

    if (self.label || self.question) {
      $label = jQuery('<label/>');

      if (self.labelClass) {
        $label.addClass(self.labelClass);
      }

      $label.append(self.label);

      if (self.question) {
        $label.append(jQuery(`<a class="cloud-question" target="_blank" rel="noopener" href="${self.question}">?</a>`));
      }

      wrap.append($label);
    }

    if (config.description) {
      wrap.append(jQuery('<blockquote class="cloud-description">' + Translator.translate(config.description) + '</blockquote>'));
    }

    $element.keyup(function() {
      let $value = jQuery(this).val();
      if ($value.match(regex)) {
        self.picker.setDate(self.picker.parseDate($value), false, pickerFormat);
      }
    });

    return $element;
  };

  self.afterRender = function() {
    let $trash = jQuery('<div class="input-group-append"><span class="input-group-text icon icon-trash"></span></div>');

    $trash.on('click', 'span.icon-trash', function() {
      self.picker.clear();
    });

    return $trash;
  };

  self.getData = function() {
    const dates = self.picker.selectedDates;

    if (dates.length && config.range) {
      return [
        dateFormat(dates[0], pickerFormat + ' 00:00:00'),
        dateFormat(dates[1], pickerFormat + ' 23:59:59'),
      ];
    }

    return dates[0] && !isNaN(dates[0]) && typeof dates[0] !== 'undefined' ? dateFormat(dates[0], pickerFormat) : '';
  };

  return self;
});
